import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../../../layouts/PageTitle';
import AnnouncementApiService from '../../../../services/superadmin/AnnouncementApiService';
import MenuConfig from '../../../../constants/MenuConfig';
import { errorAlert, warnAlertYesOrNo } from '../../../components/alert/defaultAlert';
import FormSection from '../../../components/Common/Form/FormSection';
import './Announcement.css';

const statusBadge = (item) => {
    if (item.status === 'INACTIVE') return <Badge className="announcement__status announcement__status--inactive">Inativo</Badge>;
    if (item.expiresAt && new Date(item.expiresAt) < new Date()) return <Badge className="announcement__status announcement__status--expired">Expirado</Badge>;
    return <Badge className="announcement__status announcement__status--active">Ativo</Badge>;
};

const AnnouncementList = () => {
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(() => {
        setLoading(true);
        AnnouncementApiService.findAll()
            .then(resp => setItems(resp.data))
            .catch(err => errorAlert(err))
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => { load(); }, [load]);

    const handleRemove = (id) => {
        warnAlertYesOrNo('Deseja remover este comunicado?', () => {
            AnnouncementApiService.remove(id)
                .then(() => load())
                .catch(err => errorAlert(err));
        });
    };

    return (
        <>
            <PageTitle activeMenu="Comunicados" motherMenu="Administração" />

            <div className="form-layout form-layout--spaced">
                <FormSection
                    title="Comunicados da plataforma"
                    description="Gerencie os informativos exibidos para todos os tenants."
                    icon="fa-solid fa-bullhorn"
                    actions={<button
                            className="btn btn-primary"
                            onClick={() => navigate(MenuConfig.superadmin.announcement.newRoute)}
                        >
                            <i className="fa-solid fa-plus me-2" />
                            Novo Comunicado
                        </button>}
                >

                    {loading ? (
                        <p className="text-muted">Carregando...</p>
                    ) : items.length === 0 ? (
                        <p className="text-muted">Nenhum comunicado cadastrado.</p>
                    ) : (
                        <Row className="g-3">
                            {items.map(item => (
                                <Col xl={12} key={item.id}>
                                    <div className="announcement__item d-flex align-items-start justify-content-between p-3 gap-3">
                                        <div className="flex-grow-1">
                                            <div className="d-flex align-items-center gap-2 mb-1">
                                                <strong>{item.title}</strong>
                                                {statusBadge(item)}
                                            </div>
                                            {item.body && (
                                                <p className="text-muted mb-1" style={{ fontSize: 13, whiteSpace: 'pre-line' }}>
                                                    {item.body.length > 120 ? item.body.slice(0, 120) + '...' : item.body}
                                                </p>
                                            )}
                                            <small className="text-muted">
                                                Criado em: {item.createdAt?.slice(0, 10)}
                                                {item.expiresAt && ` · Expira: ${item.expiresAt?.slice(0, 16).replace('T', ' ')}`}
                                            </small>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <button
                                                className="btn btn-sm announcement__edit"
                                                title="Editar"
                                                onClick={() => navigate(`${MenuConfig.superadmin.announcement.newRoute}/${item.id}`)}
                                            >
                                                <i className="fa-solid fa-pen" />
                                            </button>
                                            <button
                                                className="btn btn-sm btn-danger"
                                                title="Remover"
                                                onClick={() => handleRemove(item.id)}
                                            >
                                                <i className="fa-solid fa-trash" />
                                            </button>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    )}
                </FormSection>
            </div>
        </>
    );
};

export default AnnouncementList;
